import "./Home.module.css";
import NavegaciNPrincipal from "@/reusable_sections/Header";
import CumpleSinComplicarte from "./sections/CumpleSinComplicarte";
import UrgenciaReforma2025Art62 from "./sections/UrgenciaReforma2025Art62";
import SectoresProtegidos from "./sections/SectoresProtegidos";
import EficienciaOperativa from "./sections/EficienciaOperativa";
import MDulosDeInteligenciaPld from "./sections/MDulosDeInteligenciaPld";
import Featuredindustries from "./sections/Featuredindustries";
import Howitworks from "./sections/Howitworks";
import Planesresumidos from "./sections/Planesresumidos";
import Faqprincipal from "./sections/Faqprincipal";
import Ctafinal from "./sections/Ctafinal";
import Finalcalltoaction from "./sections/Finalcalltoaction";
import PieDePGina from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <NavegaciNPrincipal />
      <CumpleSinComplicarte />
      <UrgenciaReforma2025Art62 />
      <SectoresProtegidos />
      <EficienciaOperativa />
      <MDulosDeInteligenciaPld />
      <Featuredindustries />
      <Howitworks />
      <Planesresumidos />
      <Faqprincipal />
      <Ctafinal />
      <Finalcalltoaction />
      <PieDePGina />
    </div>;
}